exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".matrix[data-v-047b7c01]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border:5px solid #646464;border-radius:12px;overflow:hidden}.matrix .mask[data-v-047b7c01],.matrix ul[data-v-047b7c01]{display:-webkit-box;display:-ms-flexbox;display:flex}.matrix .mask[data-v-047b7c01]{position:absolute;width:100%;height:100%;top:0;left:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:2rem;background:rgba(0,0,0,.3)}", ""]);

// exports
